import { LoginPage } from "./pages";

export const routes = [
  {
    path: "",
    private: false,
    element: <LoginPage />,
  },
];
